var version = '6.7.0';

module.exports = version;
